/**
 * Hook for check-in new revision (POST api/check-in/new-revision).
 * Slice holds isLoading, isError, message, data. Create pattern – no heavy dispatch logic.
 */
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  checkinNewRevisionThunk,
  resetCheckinNewRevision,
  setCheckinDialogOpen,
  consumeNavigateToAllDocuments,
} from "../slices/documents/checkinNewRevisionSlice";

function selectCheckinNewRevision(state) {
  return state.CheckinNewRevision ?? {};
}

export function useCheckinNewRevision() {
  const dispatch = useAppDispatch();
  const slice = useAppSelector(selectCheckinNewRevision);

  const submitCheckinNewRevision = useCallback(
    (payload) => dispatch(checkinNewRevisionThunk(payload)),
    [dispatch]
  );

  const reset = useCallback(() => dispatch(resetCheckinNewRevision()), [dispatch]);
  const closeDialog = useCallback(() => dispatch(setCheckinDialogOpen(false)), [dispatch]);
  const consumeNavigation = useCallback(
    () => dispatch(consumeNavigateToAllDocuments()),
    [dispatch],
  );

  return {
    submitCheckinNewRevision,
    resetCheckinNewRevision: reset,
    closeCheckinDialog: closeDialog,
    data: slice.data,
    isLoading: slice.isLoading,
    isError: slice.isError,
    message: slice.message,
    isDialogOpen: slice.isDialogOpen,
    navigateToAllDocuments: slice.navigateToAllDocuments ?? false,
    consumeNavigateToAllDocuments: consumeNavigation,
  };
}
